var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg404Blue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1484_14186",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 81,
    height: 80
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80.5 0H0.5V80H80.5V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1484_14186)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M67.0674 33.3335V60.0002C67.0674 70.0002 63.7341 73.3335 53.7341 73.3335H27.0675C17.0675 73.3335 13.7341 70.0002 13.7341 60.0002V33.3335H67.0674Z",
    fill: "#016FD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.1667 23.3337V26.667C72.1667 30.3337 70.4 33.3337 65.5 33.3337H15.5C10.4 33.3337 8.83337 30.3337 8.83337 26.667V23.3337C8.83337 19.667 10.4 16.667 15.5 16.667H65.5C70.4 16.667 72.1667 19.667 72.1667 23.3337Z",
    fill: "#016FD0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M39.2994 16.665H20.8993C19.766 15.4317 19.7993 13.5317 20.9993 12.3317L25.7327 7.59834C26.966 6.36501 28.9993 6.36501 30.2327 7.59834L39.2994 16.665Z",
    fill: "#016FD0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M60.067 16.665H41.667L50.7337 7.59834C51.967 6.36501 54.0003 6.36501 55.2337 7.59834L59.967 12.3317C61.167 13.5317 61.2003 15.4317 60.067 16.665Z",
    fill: "#016FD0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M30.2998 33.3335V50.4668C30.2998 53.1335 33.2331 54.7002 35.4663 53.2668L38.5997 51.2002C39.733 50.4668 41.1663 50.4668 42.2663 51.2002L45.233 53.2002C47.433 54.6668 50.3997 53.1002 50.3997 50.4335V33.3335H30.2998Z",
    fill: "#016FD0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404Blue);
export default __webpack_public_path__ + "static/media/404_blue.0b83c73c65f011500183198eddf15bae.svg";
export { ForwardRef as ReactComponent };